import { createRouter, createWebHistory } from 'vue-router';
import {
  Page,
  Menu,
  Contacts,
  Maps,
  Footer,
} from 'sputnik-ui/src/index';
import Home from './pages/Home.vue'
import Partners from './pages/Partners.vue';
import About from './pages/About.vue';
import Prikaz511 from './pages/Prikaz511.vue';
import Feedback from './pages/Feedback.vue';
import Documents from './pages/Documents.vue';
import License from './pages/License.vue';
import Scanner from './pages/projects/Scanner.vue';
import SearchForDevices from './pages/projects/SearchForDevices.vue';
import ClientProfile from './pages/projects/ClientProfile.vue';
import Depersonalization from './pages/projects/Depersonalization.vue';
import DataGenerator from './pages/projects/DataGenerator.vue';
import Analytics from './pages/projects/Analytics.vue';
import SearchForDatasets from './pages/projects/SearchForDatasets.vue';
import { changeUrl } from './utils/changeUrl';

const createMenuItems = () => [
  { text: 'О компании', submenu: [
    { text: 'О компании', onClick: () => changeUrl('/about') },
    { text: 'Приказ Минцифры №511', onClick: () => changeUrl('/prikaz511') },
    { text: 'Партнеры', onClick: () => changeUrl('/partners') },
    { text: 'Лицензии и сертификаты', onClick: () => changeUrl('/license')},
    { text: 'Документы', onClick: () => changeUrl('/documents')},
    { text: 'Контакты', onClick: () => changeUrl('/contacts') }
  ]},
  { text: 'Проекты', submenu: [
    { text: 'Сканер уязвимостей', onClick: () => changeUrl('/scanner') },
    { text: 'Сервис поиска устройств IoT', onClick: () => changeUrl('/search-for-devices') },
    { text: 'Сервис аналитики', onClick: () => changeUrl('/analytics') },
    { text: 'Профиль клиента', onClick: () => changeUrl('/client-profile') },
    { text: 'Обезличивание', onClick: () => changeUrl('/depersonalization') },
    { text: 'Генератор синтетических данных', onClick: () => changeUrl('/data-generator') },
    // { text: 'Сервис поиска датасетов', onClick: () => changeUrl('/search-for-datasets') },
  ]},
];

const createPage = (components) =>
  <Page>
    <Menu items = {createMenuItems()} onClickLogo={() =>changeUrl('/')} />
    {components}
    <Footer items={createMenuItems().map(item => {
      if (item.text === 'О компании') {
        return {
          ...item,
          submenu: [
            ...item.submenu,
            { text: 'Ростелеком', onClick: () => window.open('https://rt.ru/', '_blank') }
          ]
        };
      }
      return item;
    })} />
  </Page>

const routes = [
  {
    path: '/feedback',
    name: 'Feedback',
    component: createPage(<Feedback />)
  },
  {
    path: '/',
    name: 'Home',
    component: createPage(<Home />)
  },
  {
    path: '/about',
    name: 'About',
    component: createPage(<About />)
  },
  {
    path: '/prikaz511',
    name: 'Prikaz511',
    component: createPage(<Prikaz511 />)
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: createPage(<><Contacts theme='dark' email="info@sputnik.ru" /><Maps /></>)
  },
  {
    path: '/partners',
    name: 'About Partners',
    component: createPage(<Partners />)
  },
  {
    path: '/documents',
    name: 'Documents',
    component: createPage(<Documents />)
  },
  {
    path: '/license',
    name: 'License',
    component: createPage(<License />)
  },
  {
    path: '/scanner',
    name: 'Scanner',
    component: createPage(<Scanner />)
  },
  {
    path: '/search-for-devices',
    name: 'SearchForDevices',
    component: createPage(<SearchForDevices />)
  },
  {
    path: '/search-for-datasets',
    name: 'SearchForDatasets',
    component: createPage(<SearchForDatasets />)
  },
  {
    path: '/client-profile',
    name: 'ClientProfile',
    component: createPage(<ClientProfile />)
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: createPage(<Analytics />)
  },
  {
    path: '/depersonalization',
    name: 'Depersonalization',
    component: createPage(<Depersonalization />)
  },
  {
    path: '/data-generator',
    name: 'DataGenerator',
    component: createPage(<DataGenerator />)
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
